import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ApiService } from '@angular/synthrone-design/services';

@Component({
  selector: 'custom-product-sections-editor',
  templateUrl: './custom-product-sections-editor.component.html',
  styleUrls: ['./custom-product-sections-editor.component.scss']
})
export class CustomProductSectionsEditorComponent implements OnInit {

  customLabelToggle = [];
  icon = [];
  title = [];
  dataObject;
  templatePrefix;
  defaultObject;
  sections;
  isExisting = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected api: ApiService,
    public dialogRef: MatDialogRef<CustomProductSectionsEditorComponent>,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.customLabelToggle = [];
    this.icon = [];
    this.title = [];

    this.dataObject = this.data[0];
    this.templatePrefix = this.data[1];
    this.defaultObject = this.data[2];
    this.sections = Object.keys(this.defaultObject);

    if (!this.dataObject) {
      this.dataObject = this.defaultObject;
    }

    if (this.isJsonString(this.dataObject)) {
      this.dataObject = JSON.parse(this.dataObject);
    }

    const objectKeys = Object.keys(this.dataObject);
    const objectValues = objectKeys.map((key) => this.dataObject[key]);

    // check if sections templates exist in resources
    this.getAllSectionsTemplate();

    // parsing object from strings to pure booleans or objects
    objectValues.forEach(item => {
      if (item.hasOwnProperty('customLabel') && item.customLabel) {
        item.customLabel = JSON.parse(JSON.stringify(item.customLabel));
      }
    });

    objectKeys.forEach(item => {
      this.customLabelToggle[item] = Boolean(this.dataObject[item].customLabel['icon'] || this.dataObject[item].customLabel['title']);

      if (this.customLabelToggle[item]) {
        this.icon[item] = this.dataObject[item].customLabel.icon;
        this.title[item] = this.dataObject[item].customLabel.title;
      }
    });
  }

  closeWindow = (data = null) => {
    this.dialogRef.close(data);
  }

  save = () => {
    this.closeWindow([this.dataObject, this.templatePrefix]);
  }

  isJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  checkJsonFields(section) {
    this.dataObject[section].customLabel = {'icon': this.icon[section] && this.customLabelToggle[section] ? this.icon[section] : null, 'title': this.title[section] && this.customLabelToggle[section] ? this.title[section] : null};
  }

  getAllSectionsTemplate = () => {
    if (this.templatePrefix && !this.isExisting.length) {
      this.api.makeRequest('api_system_templates_exist', {sections: this.sections, templatePrefix: this.templatePrefix}, 'crafter').subscribe((result: any) => {
        this.isExisting = result;
      });
    }
  }

  getSectionName = (section) => {
    return section.replace('synthrone', '');
  }

  disableCustomTemplates = () => {
    Object.keys(this.dataObject).forEach(section => {
      this.dataObject[section]['customTemplate'] = false;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/forms/custom-product-sections-editor/custom-product-sections-editor.component.ts